import { render, staticRenderFns } from "./NpwpView.vue?vue&type=template&id=42674ec8"
import script from "./NpwpView.vue?vue&type=script&lang=js"
export * from "./NpwpView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports